import { makeStyles } from "@material-ui/core/styles";
import { ToggleInput } from "components/filters/ToggleInputs";
import { DateInput } from "components/inputs";
import { CompanySelect } from "components/inputs";
import { NumberInputEx } from "components/inputs";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { NotCustomerRoles } from "entities/UserRole";
import React from "react";
import { AutocompleteInput, Filter, ReferenceInput, TextInput, useListContext } from "react-admin";
import { usePermissions } from "react-admin";

const useStyles = makeStyles({
	filterContainer: {
		"& .filter-field": {
			display: "flex",
			alignItems: "center",
		},
		display: "flex",
		alignItems: "center",
	},
});

export const InventoryListFilter = (props) => {
	const classes = useStyles();
	const { permissions } = usePermissions();
	const { translate } = props;
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const { filterValues } = useListContext();
	const isNotCustomerRole = permissions?.role && NotCustomerRoles.includes(permissions.role);
	const hideCompanyFilter = !isNotCustomerRole;

	const productFilterParams = {
		no_range: true,
		...(globalFilters?.terminal_id?.[0] && { terminal_id: globalFilters.terminal_id[0] }),
	};

	if (!isNotCustomerRole && permissions?.company_id) {
		productFilterParams.company_id = permissions.company_id;
	} else {
		if (filterValues?.company_id) {
			productFilterParams.company_id = filterValues.company_id;
		}
	}

	return (
		<Filter {...props} className={classes.filterContainer}>
			<ToggleInput
				source="is_expiration_report"
				label={translate("resources.inventory-list.is_expiration_report")}
				alwaysOn
			/>
			<DateInput
				label={translate("resources.invantory-list.filters.as_of_date")}
				source="as_of_date"
				alwaysOn
			/>
			<NumberInputEx label={translate("tab.pallets.pallet_id")} source="id" alwaysOn />
			<TextInput label={translate("tab.pallets.sscc")} source="sscc" alwaysOn />
			<TextInput label={translate("tab.pallets.sscc_original")} source="sscc_original" />
			<TextInput label={translate("tab.pallets.gtin")} source="gtin" />
			<NumberInputEx
				type="digits"
				label={translate("tab.pallets.external_id")}
				source="ext_id"
				alwaysOn
			/>

			{!hideCompanyFilter && (
				<CompanySelect
					source="company_id"
					emptyValue={null}
					emptyText="All Companies"
					defaultValue={null}
					alwaysOn
					allowEmpty
					resettable
				/>
			)}

			{productFilterParams.company_id && (
				<ReferenceInput
					label={translate("tab.pallets.product_number")}
					source="product_number"
					reference="product-numbers"
					filter={productFilterParams}
					alwaysOn
					resettable
				>
					<AutocompleteInput optionText="product_number" />
				</ReferenceInput>
			)}

			{productFilterParams.company_id && (
				<ReferenceInput
					label={translate("tab.pallets.product_name")}
					source="product_name"
					reference="product-names"
					filter={productFilterParams}
					alwaysOn
					resettable
				>
					<AutocompleteInput optionText="product_name" />
				</ReferenceInput>
			)}

			<TextInput label={translate("tab.pallets.ceel_number")} source="ceel_number" />
			<TextInput label={translate("tab.pallets.batch_number")} source="batch_number" />
			<TextInput label={translate("tab.pallets.lot_number")} source="lot_number" />
			<TextInput label={translate("tab.pallets.packing_station")} source="packing_station" />

			<DateInput
				label={translate("tab.pallets.expiration_datetime")}
				source="expiration_datetime"
			/>
			<DateInput
				label={translate("tab.pallets.production_datetime")}
				source="production_datetime"
			/>
			<TextInput label={translate("tab.pallets.incoming_order_ref")} source="incoming_order_ref" />
		</Filter>
	);
};
